// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2GQUr","title":"styles_title__30oWx","subtitle":"styles_subtitle__2yC3m"};